/**
 * Koffer-Hilfsfunktionen
 */
import { DEVICE_CONSTANTS, DEVICE_VALUE_FIELDS } from './deviceConstants';

/**
 * Berechnet Koffer-Metriken (Qualität, Temperatur, Online-Status)
 */
export const calculateDeviceMetrics = (panel) => {
  if (!panel) {
    return {
      quality: 1,
      temperature: 1,
      qualityCalc: 1,
      isOnline: false
    };
  }
  
  // Lese Signal-Qualität und Temperatur
  const quality = panel[DEVICE_VALUE_FIELDS.SIGNAL_QUALITY] || 1;
  const temperature = panel[DEVICE_VALUE_FIELDS.TEMPERATURE] || 1;
  
  // Berechne Qualität (1-30) durch Division und Begrenzung
  let qualityCalc = Math.round(quality / DEVICE_CONSTANTS.QUALITY_CALC_DIVISOR);
  qualityCalc = Math.max(DEVICE_CONSTANTS.QUALITY_MIN, Math.min(DEVICE_CONSTANTS.QUALITY_MAX, qualityCalc));
  
  // Prüfe Online-Status
  const isOnline = isDeviceOnline(panel);
  
  return { quality, temperature, qualityCalc, isOnline };
};

/**
 * Prüft ob ein Panel online ist
 * 
 * Ein Panel gilt als online, wenn der letzte Request innerhalb der
 * Schwellenzeit (Standard: 5 Minuten) liegt.
 * 
 * @param {Object} panel - Panel-Objekt
 * @param {number} thresholdMinutes - Minuten-Schwelle (Standard: 30)
 * @returns {boolean} true wenn Panel online, sonst false
 * 
 * @example
 * const online = isDeviceOnline(panel, 30);
 * // true oder false
 */
export const isDeviceOnline = (panel, thresholdMinutes = DEVICE_CONSTANTS.OFFLINE_THRESHOLD_MINUTES) => {
  if (!panel || !panel[DEVICE_VALUE_FIELDS.CREATED]) {
    return false;
  }
  
  try {
    const lastRequestTime = new Date(panel[DEVICE_VALUE_FIELDS.CREATED]).getTime();
    if (isNaN(lastRequestTime)) {
      return false;
    }
    
    // Berechne Schwellenzeit (jetzt - thresholdMinutes)
    const threshold = Date.now() - (thresholdMinutes * 60000);
    return lastRequestTime > threshold;
  } catch (error) {
    console.error('Fehler beim Prüfen des Online-Status:', error);
    return false;
  }
};

export const validateDeviceData = (data) => {
  if (!data) {
    return [];
  }
  if (!Array.isArray(data)) {
    return [];
  }
  return data.filter((panel) => panel && panel.id);
};
